import { CommonModule, NgClass } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { getKey } from "pax-ui/core";

import { Emoji, emojiAltMapping } from "./emoji-alt-mapping";

export type EmojiSize = "inline" | "small" | "medium" | "large";

const SizesClassMap: Record<EmojiSize, string> = {
  inline: "w-5 h-5",
  small: "w-8 h-8",
  medium: "w-14 h-14",
  large: "w-24 h-24",
};

@Component({
  selector: "pax-emoji",
  imports: [CommonModule],
  templateUrl: "./emoji.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmojiComponent implements OnChanges {
  @Input({ required: true }) character!: Emoji;

  @Input() size: EmojiSize = "medium";

  imageClassName: NgClass["ngClass"] = SizesClassMap[this.size];

  get emojiSource() {
    return `https://emojicdn.elk.sh/${this.character}`;
  }

  get altText() {
    return emojiAltMapping[this.character];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes[getKey<EmojiComponent>("size")]) {
      this.imageClassName = SizesClassMap[this.size];
    }
  }
}
